import * as React from 'react';
import { useEffect, useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '../styles/variables';
import { NoticeSection } from '../atoms/notice_section';
const selectedBadgeImgPath = 'assets/images/select_plan/selected_badge_gray.png';
export const CampaignPlanSection = ({ classObject, isBulkRegistration, // TODO: 一括登録フォームのみになったら削除
isCampaignSimplifiedView, campaign, campaignPlan, withCampaignParams, apiClient, friendInvitationCampaign, }) => {
    const [regularPlan, setRegularPlan] = useState(null);
    useEffect(() => {
        apiClient.fetchRegistablePlans(false).then((plans) => {
            setRegularPlan(plans[0]);
        });
    }, [apiClient]);
    const appliedLabel = withCampaignParams ? 'が適用されています' : 'が適用されました';
    const comparisonPlan = (campaignPlan === null || campaignPlan === void 0 ? void 0 : campaignPlan.isFirstYearCampaignPlan) ? campaignPlan.nextPlan : regularPlan === null || regularPlan === void 0 ? void 0 : regularPlan.plan;
    const hasFriendInvitationCampaignImage = (friendInvitationCampaign === null || friendInvitationCampaign === void 0 ? void 0 : friendInvitationCampaign.isHolding) && !!(friendInvitationCampaign === null || friendInvitationCampaign === void 0 ? void 0 : friendInvitationCampaign.paymentImageURL);
    const friendInvitationGiftPrice = hasFriendInvitationCampaignImage
        ? friendInvitationCampaign.amazonGiftPrice.toLocaleString()
        : '1,500';
    let priceImgSrc;
    if (campaign.isFirstYearFriendInvitation) {
        priceImgSrc = hasFriendInvitationCampaignImage
            ? friendInvitationCampaign.paymentImageURL
            : '/assets/images/signup/friend_invitation.png';
    }
    else if (campaign.isCommotYearEndCP) {
        priceImgSrc = '/assets/images/signup/campaign_plan_price_commot_year_end.png';
    }
    else if (campaign.isCommotTrial30Days) {
        priceImgSrc = '/assets/images/signup/campaign_plan_price_commot_trial_30days.png';
    }
    else if (campaign.isAmazonPayCPCP) {
        priceImgSrc = '/assets/images/signup/campaign_plan_price_amazon_pay_cp.png';
    }
    else {
        priceImgSrc = '/assets/images/signup/campaign_plan_price.png';
    }
    // TODO: 一括登録フォームのみになったら削除
    if (!isBulkRegistration) {
        return (React.createElement(NoticeSection, null,
            React.createElement("div", null,
                React.createElement("span", { className: css(styles.campaignName) }, campaign.name),
                appliedLabel)));
    }
    if (isCampaignSimplifiedView) {
        return (React.createElement(NoticeSection, null,
            React.createElement("div", null,
                React.createElement("span", { className: css(styles.campaignName) }, campaign.name),
                appliedLabel)));
    }
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.content) },
            React.createElement("img", { className: css(styles.checkIcon), src: selectedBadgeImgPath, alt: "selected badge" }),
            React.createElement("div", { className: css(styles.campaignNameAndPrice) },
                React.createElement("div", null,
                    React.createElement("span", { className: css(styles.campaignName) }, campaign.name),
                    appliedLabel),
                React.createElement("img", { src: priceImgSrc, className: css(styles.image), alt: campaign.isFirstYearFriendInvitation
                        ? `2週間無料体験後、初年度は1ヶ月あたり980円（税込1,078円）相当。Amazonギフトカード${friendInvitationGiftPrice}円分プレゼント`
                        : '' }))),
        React.createElement("div", { className: css(styles.text) },
            campaign.isFirstYearFriendInvitation && '無料体験終了後',
            campaign.isFirstYearFriendInvitation ? campaign.name : '特別キャンペーン12ヶ月プラン',
            ' ',
            campaign.isCommotYearEndCP || campaign.isCommotTrial30Days ? (`${campaignPlan.amount.toLocaleString()}円(税込)のご登録`) : (React.createElement(React.Fragment, null,
                comparisonPlan && (React.createElement("span", { className: css(styles.strikethrough) },
                    comparisonPlan.amountWithoutTax.toLocaleString(),
                    "\u5186 (\u7A0E\u8FBC",
                    comparisonPlan.amount.toLocaleString(),
                    "\u5186)")),
                campaignPlan.isFirstYearCampaignPlan ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: css(styles.firstYearPrice) },
                        campaignPlan.amountWithoutTax.toLocaleString(),
                        "\u5186\uFF08\u7A0E\u8FBC",
                        campaignPlan.amount.toLocaleString(),
                        "\u5186\uFF09"),
                    ' ',
                    "\u306E\u3054\u767B\u9332")) : (`${campaignPlan.amountWithoutTax.toLocaleString()}円(税込${campaignPlan.amount.toLocaleString()}円)のご登録`)))),
        React.createElement("div", { className: css(styles.text) },
            (campaignPlan.isFirstYearCampaignPlan || !withCampaignParams) && !campaignPlan.hasFreeTrial() && (React.createElement(React.Fragment, null,
                "\u203B\u7121\u6599\u671F\u9593\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002",
                React.createElement("br", null))),
            campaignPlan.isFirstYearCampaignPlan ? (React.createElement("span", null,
                "\u203B\u521D\u5E74\u5EA6\u306E\u307F\u7279\u5225\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u4FA1\u683C\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u30022\u5E74\u76EE\u4EE5\u964D\u306F",
                campaignPlan.nextPlan.name,
                ' ',
                campaignPlan.nextPlan.amountWithoutTax.toLocaleString(),
                "\u5186\uFF08\u7A0E\u8FBC",
                campaignPlan.nextPlan.amount.toLocaleString(),
                "\u5186\uFF09\u3067\u81EA\u52D5\u66F4\u65B0\u3068\u306A\u308A\u307E\u3059\u3002")) : ('※翌年更新時も特別キャンペーン12ヶ月プランが適用となります。'),
            React.createElement("br", null),
            campaignPlan.isFirstYearCampaignPlan
                ? '※継続をご希望されない場合は、次回更新日までに設定から退会手続きをお願いします。'
                : '※自動更新となるため、継続をご希望されない場合は設定から退会手続きをお願いします。',
            campaign.isCommotYearEndCP ? (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                "\u203BAmazon\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306F\u30012\u67081\u65E5\u301C2\u670810\u65E5\u307E\u3067\u306B\u3054\u767B\u9332\u3044\u305F\u3060\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3078\u9001\u4ED8\u3044\u305F\u3057\u307E\u3059\u3002")) : campaign.isAmazonPayCPCP ? (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                "\u203BAmazon\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306E\u30D7\u30EC\u30BC\u30F3\u30C8\u306FAmazon Pay\u306B\u3066\u304A\u652F\u6255\u3044\u3044\u305F\u3060\u3044\u305F\u65B9\u306E\u3046\u3061\u5148\u7740100\u540D\u69D8\u304C\u5BFE\u8C61\u3068\u306A\u308A\u307E\u3059\u3002\u5BFE\u8C61\u306E\u65B9\u306B\u306F1\u670816\u65E5\u307E\u3067\u306B\u3054\u767B\u9332\u3044\u305F\u3060\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3078\u9001\u4ED8\u3044\u305F\u3057\u307E\u3059\u3002")) : (campaign.isFirstYearFriendInvitation && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                "\u203BAmazon\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u306F\u30012\u9031\u9593\u306E\u7121\u6599\u4F53\u9A13\u7D42\u4E86\u5F8C\u306B\u89E3\u7D04\u305B\u305A\u7D99\u7D9A\u3055\u308C\u305F\u65B9\u3078\u3001\u767B\u9332\u6708\u306E\u7FCC\u670810\u65E5\u307E\u3067\u306B\u3054\u767B\u9332\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5B9B\u306B\u9001\u4ED8\u3057\u307E\u3059\u3002\u7121\u6599\u671F\u9593\u4E2D\u306B\u89E3\u7D04\u3055\u308C\u305F\u5834\u5408\u306F\u5BFE\u8C61\u5916\u3067\u3059\u3002"))))));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.BackgroundLightBlueMagenta,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 11,
        padding: 16,
        fontSize: 10,
        fontWeight: 500,
    },
    content: {
        display: 'flex',
        gap: 11,
        width: '100%',
    },
    checkIcon: {
        width: 16,
        height: 16,
    },
    campaignNameAndPrice: {
        color: Colors.GrayDarkest,
        display: 'flex',
        flexDirection: 'column',
        gap: 11,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    campaignName: {
        color: Colors.Accent,
    },
    image: {
        width: '100%',
    },
    text: {
        textAlign: 'left',
        width: '100%',
        lineHeight: '140%',
        letterSpacing: 0.5,
    },
    strikethrough: {
        textDecoration: 'line-through',
        marginRight: 4,
    },
    firstYearPrice: {
        fontWeight: 'bold',
    },
});
